<form [formGroup]="formGroup">
  <label (click)="toggleClicked()">
    <ng-content select="[before]"></ng-content>
  </label>
  <mat-slide-toggle
    #toggle
    [formControlName]="formCtrlName"
    (change)="onChange.emit($event)"
    >
  </mat-slide-toggle>
  <label (click)="toggleClicked()">
    <ng-content></ng-content>
  </label>
</form>
